import { memo } from 'react';

import { CircleSlashIcon, ClockIcon } from '@air/design-icons';
import { Chip } from '@air/primitive-chip';

import { type AiModelConfig } from '../../../api/aimodels/useAiModels';
import { formatDuration } from './formatDuration';

type ModelTooltipContentProps = { model: AiModelConfig };

export const ModelTooltipContent = memo(({ model }: ModelTooltipContentProps) => (
  <div className="flex flex-col gap-2">
    <span className="font-semibold ads:text-primary text-12 text-gray-12">{model.name}</span>
    <span className="ads:text-metadata text-12 text-gray-10">{model.description}</span>
    {(model.defaultCredits !== undefined || model.defaultDurationMs !== undefined) && (
      <div className="flex items-center gap-1">
        {model.defaultCredits !== undefined && (
          <Chip color="gray" shape="rectangular" size="small">
            <CircleSlashIcon className="shrink-0" size="sm" />
            {model.defaultCredits}
          </Chip>
        )}
        {model.defaultDurationMs !== undefined && (
          <Chip color="gray" shape="rectangular" size="small">
            <ClockIcon className="shrink-0" size="xs" />
            {formatDuration(model.defaultDurationMs)}
          </Chip>
        )}
      </div>
    )}
  </div>
));

ModelTooltipContent.displayName = 'ModelTooltipContent';
